"use client";

import { useInfront } from "@/context/infront-context";
import { DEFAULT_CONTENT } from "@/services/infront/utils";
import { useEffect, useRef } from "react";

const ID = "history";

type HistoryProps = {
  instrument: {
    feed: number;
    ticker: string;
  };
};

const History = (props: HistoryProps) => {
  const { isReady, load } = useInfront();

  const widgetRef = useRef<any>(null);

  useEffect(() => {
    let active = true;

    load?.(["core", "highstock", "heikinashi", "hollowcandlestick"]).then(() => {
      if (!isReady || !active) return;

      widgetRef.current?.destroy();
      widgetRef.current = null;

      const widgetOptions = new window.Infront.HistoryWidgetOptions();

      widgetOptions.defaultContent = DEFAULT_CONTENT;
      widgetOptions.startYear = 1999;
      widgetOptions.endYear = new Date().getFullYear();
      widgetOptions.instrument = new window.Infront.Instrument(
        props.instrument.feed,
        props.instrument.ticker
      );

      widgetRef.current = window.infront.historyWidget(`#${ID}`, widgetOptions);
    });

    return () => {
      active = false;
      widgetRef.current?.destroy();
      widgetRef.current = null;
    };
  }, [isReady, props.instrument]);

  return <div className="card" id={ID} />;
};

export default History;
